import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

interface LinkItem {
  url: string;
  text: string;
}

interface InternalLinksProps {
  title?: string;
  links: LinkItem[];
  columns?: 2 | 3 | 4;
}

const LinksContainer = styled.div`
  margin: 2rem 0;
  padding: 1.5rem;
  background-color: #f8f9fa;
  border-radius: var(--border-radius);
  border: 1px solid #eee;
`;

const LinksTitle = styled.h3`
  font-size: 1.25rem;
  margin-bottom: 1rem;
  color: var(--gray-dark);
`;

const LinksList = styled.ul<{ columns: number }>`
  display: grid;
  grid-template-columns: repeat(${props => props.columns}, 1fr);
  gap: 0.75rem 1.5rem;
  list-style: none;
  padding: 0;
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }
  
  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

const LinkItem = styled.li`
  a {
    display: block;
    color: var(--blue);
    text-decoration: none;
    font-size: 0.95rem;
    padding: 0.25rem 0;
    
    &:hover {
      text-decoration: underline;
    }
    
    &::before {
      content: "→";
      display: inline-block;
      margin-right: 0.5rem;
      color: var(--blue);
    }
  }
`;

const InternalLinks: React.FC<InternalLinksProps> = ({ 
  title = "Enlaces relacionados", 
  links,
  columns = 3
}) => {
  if (!links || links.length === 0) {
    return null;
  }
  
  return (
    <LinksContainer>
      <LinksTitle>{title}</LinksTitle>
      <LinksList columns={columns}>
        {links.map((link, index) => (
          <LinkItem key={index}>
            <Link to={link.url}>{link.text}</Link>
          </LinkItem>
        ))}
      </LinksList>
    </LinksContainer>
  );
};

export default InternalLinks; 